import React, { useState } from 'react';
import update from 'immutability-helper';

import EkovillaContext from '../contexts/EkovillaContext';

function EkovillaProvider(props) {

    const [state, setState] = useState({
        ekovilla: {
            0: {
                part: "Yläpohja, suora",
                product: "Ekovilla puhallusvilla",
                area: 0,
                thickness: 0,
                insulationCubic: 0,
                insulationWeight: 0
            },
            1: {
                part: "Yläpohja, ontelo",
                product: "Ekovilla puhallusvilla",
                area: 0,
                thickness: 0,
                insulationCubic: 0,
                insulationWeight: 0
            },
            2: {
                part: "Seinä",
                product: "Ekovilla puhallusvilla",
                area: 0,
                thickness: 0,
                insulationCubic: 0,
                insulationWeight: 0
            },
            3: {
                part: "Alapohja",
                product: "Ekovilla puhallusvilla",
                area: 0,
                thickness: 0,
                insulationCubic: 0,
                insulationWeight: 0
            }
        },
        competitor: {
            0: {
                comPart: "Yläpohja, suora",
                comArea: 0,
                comThickness: 0,
                comInsulationCubic: 0,
                comInsulationThicknessCubic: 0,
                comCarbonFoot: 0,
                comCarbonHand: 0
            },
            1: {
                comPart: "Yläpohja, ontelo",
                comArea: 0,
                comThickness: 0,
                comInsulationCubic: 0,
                comInsulationThicknessCubic: 0,
                comCarbonFoot: 0,
                comCarbonHand: 0
            },
            2: {
                comPart: "Seinä",
                comArea: 0,
                comThickness: 0,
                comInsulationCubic: 0,
                comInsulationThicknessCubic: 0,
                comCarbonFoot: 0,
                comCarbonHand: 0
            },
            3: {
                comPart: "Alapohja",
                comArea: 0,
                comThickness: 0,
                comInsulationCubic: 0,
                comInsulationThicknessCubic: 0,
                comCarbonFoot: 0,
                comCarbonHand: 0
            }
        },
    });

    const countCubic = (area, thickness) => {
        const cubic = area * thickness / 1000;
        return Math.round(cubic * 10) / 10;
    }

    const countWeight = (cubic, part, product) => {

        let density = 0;
        let weight = 0;

        if (part === "Yläpohja, suora") {
            density = 32;
            weight = cubic * density;
            return Math.round(weight * 10) / 10;
        } else if (part === "Yläpohja, ontelo") {
            density = 45;
            weight = cubic * density;
            return Math.round(weight * 10) / 10;
        } else if (part === "Seinä" && product === "Ekovilla puhallusvilla") {
            density = 60
            weight = cubic * density;
            return Math.round(weight * 10) / 10;
        } else if (part === "Seinä" && product === "Ekovillalevy") {
            density = 45;
            weight = cubic * density;
            return Math.round(weight * 10) / 10;
        } else if (part === "Alapohja") {
            density = 45;
            weight = cubic * density;
            return Math.round(weight * 10) / 10;
        }
    }

    const handleStateChange = (event, key) => {
        const name = event.target.name;

        // Ekovilla variables
        const areaValue = name === "area" ? event.target.value : state.ekovilla[key].area;
        const thicknessValue = name === "thickness" ? event.target.value : state.ekovilla[key].thickness;
        const partName = state.ekovilla[key].part;
        const productName = name === "product" ? event.target.value : state.ekovilla[key].product;

        //Competitor variables
        const comAreaValue = name === "comArea" ? event.target.value : state.competitor[key].comArea;
        const comThicknessValue = name === "comThickness" ? event.target.value : state.competitor[key].comThickness;
        const comInsulationThicknessCubicValue = name === "comInsulationThicknessCubic" ? event.target.value : state.competitor[key].comInsulationThicknessCubic;
        const comCarbonFootValue = name === "comCarbonFoot" ? event.target.value : state.competitor[key].comCarbonFoot;
        const comCarbonHandValue = name === "comCarbonHand" ? event.target.value : state.competitor[key].comCarbonHand;

        let newState = {};

        if (name.indexOf('com') !== 0) {
            const cubic = countCubic(areaValue, thicknessValue);
            const weight = countWeight(cubic, partName, productName);
            newState = {
                ekovilla: {
                    [key]: {
                        [name]: { $set: event.target.value },
                        insulationCubic: { $set: cubic },
                        insulationWeight: { $set: weight }
                    }
                }
            }
        } else {
            const cubic = countCubic(comAreaValue, comThicknessValue)
            const thicknessCubic = comInsulationThicknessCubicValue;
            const carbonFoot = comCarbonFootValue;
            const carbonHand = comCarbonHandValue;
            newState = {
                competitor: {
                    [key]: {
                        [name]: { $set: event.target.value },
                        comInsulationCubic: { $set: cubic },
                        comInsulationThicknessCubic: { $set: thicknessCubic },
                        comCarbonFoot: { $set: carbonFoot },
                        comCarbonHand: { $set: carbonHand }
                    }
                }
            }
        }
        const newObj = update(state, newState);
        setState(newObj);
    }

    return (
        <EkovillaContext.Provider
            value={{
                ekovilla: state.ekovilla,
                competitor: state.competitor,
                handleStateChange: handleStateChange,
            }}>
            {props.children}
        </EkovillaContext.Provider>
    )
}

export default EkovillaProvider;